import { ErrorInfo } from "react";
import { Sentry } from "@/lib/sentry";

/**
 * Punto único de reporte para errores que un ErrorBoundary atrapa.
 * Si Sentry no está inicializado (DSN ausente), captureException es no-op,
 * pero igual loggeamos a consola para que dev local vea el error.
 */
export function reportBoundaryError(error: Error, info: ErrorInfo): void {
  console.error("[ErrorBoundary] Uncaught error", error);

  Sentry.captureException(error, {
    contexts: {
      react: { componentStack: info.componentStack ?? undefined },
    },
    tags: {
      source: "error-boundary",
      pathname:
        typeof window !== "undefined" ? window.location.pathname : "unknown",
    },
  });
}
